import React from 'react';
import { color, Stack } from '@starrez/starryui9';
import { ShieldNegativeIcon } from '@starrez/starryui';
import { ICellRenderer } from '../types';
import styled from 'styled-components';
import { strings } from '../../../../.localisation';

type CellEvent = (value: starrez.SituationResponseEnum) => boolean;

interface ISituationResponseFlagColumnProps extends ICellRenderer<starrez.SituationResponseEnum> {
    showFlag: CellEvent;
}

export const SituationResponseFlagColumn = ({ showFlag = () => false, value }: ISituationResponseFlagColumnProps) => {
    return showFlag(value) ? (
        <StyledWrapper title={strings.Label_SituationResponseNotOK}>
            <Stack height="100%">
                <ShieldNegativeIcon />
            </Stack>
        </StyledWrapper>
    ) : (
        <></>
    );
};

export function useSituationResponseFlagColumn(showFlag: CellEvent) {
    return {
        cellRendererFramework: SituationResponseFlagColumn,
        cellRendererParams: {
            showFlag,
        },
    };
}

const StyledWrapper = styled.div`
    height: 100%;
    color: ${color.Red.R60};
    cursor: pointer;

    > * {
        cursor: pointer !important;
    }
`;
